<div id="body-container">
  <div class="background-blue">
    <div class="breadcrumbs-container container device-details-page-banner">
      <h1 style="font-size: 22.5px"><adp-label labelKey="DeviceDetails_Title"></adp-label></h1>
    </div>
  </div>

  <ng-container>
    <pgh-device-breadcrumbs class="container"></pgh-device-breadcrumbs>

    <ng-container *ngIf="!viewTestResults">
      <div class="container device-details-page" *ngIf="selDevice">
        <div class="row">
          <!-- DETAILS SECTION-->
          <div class="col-sm-4" style="border-right: 1px solid #d6d6d6;">
            <adp-setting key="DeviceDetails_AllowReceipts"></adp-setting>
            <adp-setting key="DeviceDetails_UploadReceipt_MaxUploadFileSize"></adp-setting>
            <adp-setting key="DeviceDetails_UploadReceipt_AllowedFileTypes"></adp-setting>
            <div class="adp-device-card" tabindex="0" cdkMonitorSubtreeFocus>
              <div class="device-card-container" [ngClass]="'noboxshadow'" style="background-color: white !important">
                <div class="device-card-body">
                  <div class="device-card-row device-card-row-layout device-card-row-mobile" style="align-items: flex-end">
                    <div *ngIf="!isEditDeviceEnabled" style="margin-top:20px;"></div>
                    <div *ngIf="isEditDeviceEnabled">
                      <button
                        mat-raised-button
                        class="device-card-button"
                        [matMenuTriggerFor]="deviceMenu"
                        style="cursor: pointer"
                        sf-aria-label="Global_MoreActions_Aria_Label">
                        <span>
                          <mat-icon width="16" height="16" style="overflow: visible !important">
                            <ng-container *ngTemplateOutlet="manageDeviceIcon"></ng-container>
                          </mat-icon>
                        </span>
                      </button>
                      <div #deviceDetailsMenu class="device-details-edit-menu">
                        <mat-menu #deviceMenu="matMenu">
                          <button
                            mat-menu-item
                            (click)="this.handleEditDevice()"
                            [gtmClick]="getViewLabel('DeviceDetails_Menu_EditDevice_Label')">
                            <adp-label labelKey="DeviceDetails_Menu_EditDevice_Label"></adp-label>
                          </button>
                          <button
                            mat-menu-item
                            (click)="this.handleRemoveDevice()"
                            [gtmClick]="getViewLabel('DeviceDetails_Menu_RemoveDevice_Label')">
                            <adp-label labelKey="DeviceDetails_Menu_RemoveDevice_Label"></adp-label>
                          </button>
                          <button *ngIf="allowReceipts" mat-menu-item (click)="this.handleUploadReceipt()" [gtmClick]="receiptMenuLabel">
                            {{ receiptMenuLabel }}
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                  <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid device-detail-icon-container">
                    <span>
                      <mat-icon
                        style="color: #3c4d6a; width: 100px !important; height: 100px !important; overflow: visible !important"
                        width="80"
                        height="80"
                        [svgIcon]="deviceType?.imageKey"></mat-icon>
                    </span>
                  </div>
                  <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
                    <ng-container *ngTemplateOutlet="InfoView"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- COVERAGE SECTION-->

          <div *ngIf="selDevice.deviceSource === 'EPRISM'" class="col-sm-8 coverage-section-outer-container">
            <ng-container *ngIf="showCoverageDetails">
              <div class="device-details-page-banner container" style="padding-left: 0px !important">
                <adp-label labelKey="DeviceDetails_CoverageSection_Heading"></adp-label>
              </div>
              <div class="coverages-container">
                <div class="coverage-section" style="flex-basis: 50%;flex-grow: 1;" *ngIf="hasAccidentalDamageCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"
                        ><ng-container *ngTemplateOutlet="accidentalDamageIcon"></ng-container
                      ></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1622 0.922852C13.6251 2.46131 16.4246 2.9767 19.5759 2.46131C19.9125 5.04593 19.9125 7.86901 19.5759 10.9229C19.0634 15.5382 16.264 18.869 11.1622 20.9229C6.06036 18.869 3.26087 15.5382 2.7484 10.9229C2.41053 8.11257 2.41053 5.27159 2.7484 2.46131C5.89973 2.9767 8.69922 2.46131 11.1622 0.922852ZM15.1549 6.03824C15.0238 5.905 14.849 5.82444 14.6631 5.8117C14.4772 5.79895 14.293 5.85488 14.1452 5.969L14.0687 6.03824L7.58248 12.5613C7.44034 12.6986 7.35638 12.8858 7.34812 13.0838C7.33986 13.2819 7.40793 13.4755 7.53813 13.6243C7.66833 13.7731 7.85062 13.8656 8.04698 13.8825C8.24335 13.8994 8.43864 13.8395 8.59214 13.7152L8.66863 13.6536L15.1549 7.12285C15.2973 6.97872 15.3773 6.78377 15.3773 6.58055C15.3773 6.37733 15.2973 6.18236 15.1549 6.03824Z" fill="#333333"></path></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_AccidentalCoverage_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container" style="width:98%;margin-bottom:35px;">
                    <adp-label labelKey="DeviceDetails_AccidentalCoverage_Description"></adp-label>
                  </div>
                  <div *ngIf="deductibleAccidentalDamageAmount !== undefined" class="coverage-deductible-description-container">
                    {{deductibleAccidentalDamageAmount}}
                  </div>
                </div>
                <div class="coverage-section" style="flex-basis: 50%;flex-grow: 1;" *ngIf="hasMechanicalBreakdownCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"
                        ><ng-container *ngTemplateOutlet="mechanicalBreakdownIcon"></ng-container
                      ></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M10.3803 1.79492C5.32029 1.79492 1.21362 5.90159 1.21362 10.9616C1.21362 16.0216 5.32029 20.1283 10.3803 20.1283C15.4403 20.1283 19.547 16.0216 19.547 10.9616C19.547 5.90159 15.4403 1.79492 10.3803 1.79492ZM8.54696 15.5449L3.96362 10.9616L5.25612 9.66909L8.54696 12.9508L15.5045 5.99326L16.797 7.29492L8.54696 15.5449Z" fill="#333333"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.380371 0.961426)"></rect></clipPath></defs></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_MechanicalBreakdown_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container" style="width:98%;">
                    <adp-label labelKey="DeviceDetails_MechanicalBreakdown_Description"></adp-label>
                  </div>
                  <div *ngIf="deductibleMechanicalDamageAmount !== undefined" class="coverage-deductible-description-container">
                    {{deductibleMechanicalDamageAmount}}
                  </div>
                </div>
                <div class="coverage-section" style="flex-basis: 50%;flex-grow: 1;" *ngIf="hasLossTheftCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"><ng-container *ngTemplateOutlet="theftLossIcon"></ng-container></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M10.3803 1.79492C5.32029 1.79492 1.21362 5.90159 1.21362 10.9616C1.21362 16.0216 5.32029 20.1283 10.3803 20.1283C15.4403 20.1283 19.547 16.0216 19.547 10.9616C19.547 5.90159 15.4403 1.79492 10.3803 1.79492ZM8.54696 15.5449L3.96362 10.9616L5.25612 9.66909L8.54696 12.9508L15.5045 5.99326L16.797 7.29492L8.54696 15.5449Z" fill="#333333"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.380371 0.961426)"></rect></clipPath></defs></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_LossTheft_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container" style="width:98%;">
                    <adp-label labelKey="DeviceDetails_LossTheft_Description"></adp-label>
                  </div>
                  <div *ngIf="deductibleLossTheftAmount !== undefined" class="coverage-deductible-description-container">
                    {{deductibleLossTheftAmount}}
                  </div>
                  <!--<div class="coverage-description-disclaimer-container" style="width:98%;">
                    <div><ng-container *ngTemplateOutlet="infoIcon"></ng-container></div>
                    <adp-label labelKey="DeviceDetails_LossTheft_Disclaimer"></adp-label>
                  </div>-->
                </div>
                <div class="coverage-section" style="flex-basis: 50%;flex-grow: 1;" *ngIf="hasScreenRepairCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"
                        ><ng-container *ngTemplateOutlet="mechanicalBreakdownIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <adp-label labelKey="DeviceDetails_ScreenRepair_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container" style="width:98%;">
                    <adp-label labelKey="DeviceDetails_ScreenRepair_Description"></adp-label>
                  </div>
                  <div *ngIf="deductibleScreenDamageAmount !== undefined" class="coverage-deductible-description-container">
                    {{deductibleScreenDamageAmount}}
                  </div>
                </div>

              </div>


              <div *ngIf="isSPOEEnabled" class="coverage-links-container" style="margin-top:0px;">
                <div class="outer-link-container">
                  <div class="link-container">
                    <div class="icon-container">
                      <mat-icon
                        style="color: #3c4d6a; height: 32px; width: 32px; overflow: visible !important; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="coverageInfoIcon"> </ng-container
                      ></mat-icon>
                    </div>
                    <div class="link-button-container">
                      <button
                        class="link"
                        style="vertical-align: -webkit-baseline-middle"
                        (click)="handleViewP360CoverageInformation()"
                        [gtmClick]="getViewLabel('DeviceDetails_ViewP360CoverageInfo_Button_Label')"
                        gtmLinkURL="/coverage-mobile">
                        <adp-label labelKey="DeviceDetails_ViewP360CoverageInfo_Button_Label"></adp-label>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!showCoverageDetails">
              <div class="cancelled-no-coverage-section">
                <h2><adp-label labelKey="DeviceDetails_No_Coverage_Cancelled_Eprism_Title"></adp-label></h2>
                <div *ngIf="!resourceService.isEditMode" class="cancelled-no-coverage-text">{{noCoverageDueToCancelledEprismText}}
                </div>
                <div *ngIf="resourceService.isEditMode">
                  <adp-label labelKey="DeviceDetails_No_Coverage_Cancelled_Eprism_Text"></adp-label>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="selDevice.deviceSource !== 'EPRISM'" class="col-sm-8 coverage-section-outer-container">
            <!-- Display when there is SOME coverage for the device -->
            <ng-container *ngIf="showCoverageDetails">
              <div class="device-details-page-banner container" style="padding-left: 0px !important">
                <adp-label labelKey="DeviceDetails_CoverageSection_Heading"></adp-label>
              </div>

              <div class="coverages-container" ifSettingFalse="Global_DeviceDetails_Benefits_Enabled">
                <div class="coverage-section" style="margin-right: 20px" *ngIf="hasAccidentalDamageCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"
                        ><ng-container *ngTemplateOutlet="accidentalDamageIcon"></ng-container
                      ></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1622 0.922852C13.6251 2.46131 16.4246 2.9767 19.5759 2.46131C19.9125 5.04593 19.9125 7.86901 19.5759 10.9229C19.0634 15.5382 16.264 18.869 11.1622 20.9229C6.06036 18.869 3.26087 15.5382 2.7484 10.9229C2.41053 8.11257 2.41053 5.27159 2.7484 2.46131C5.89973 2.9767 8.69922 2.46131 11.1622 0.922852ZM15.1549 6.03824C15.0238 5.905 14.849 5.82444 14.6631 5.8117C14.4772 5.79895 14.293 5.85488 14.1452 5.969L14.0687 6.03824L7.58248 12.5613C7.44034 12.6986 7.35638 12.8858 7.34812 13.0838C7.33986 13.2819 7.40793 13.4755 7.53813 13.6243C7.66833 13.7731 7.85062 13.8656 8.04698 13.8825C8.24335 13.8994 8.43864 13.8395 8.59214 13.7152L8.66863 13.6536L15.1549 7.12285C15.2973 6.97872 15.3773 6.78377 15.3773 6.58055C15.3773 6.37733 15.2973 6.18236 15.1549 6.03824Z" fill="#333333"></path></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_AccidentalCoverage_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container">
                    <adp-label labelKey="DeviceDetails_AccidentalCoverage_Description"></adp-label>
                  </div>
                </div>
                <div class="coverage-section" style="margin-right: 20px" *ngIf="hasMechanicalBreakdownCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"
                        ><ng-container *ngTemplateOutlet="mechanicalBreakdownIcon"></ng-container
                      ></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M10.3803 1.79492C5.32029 1.79492 1.21362 5.90159 1.21362 10.9616C1.21362 16.0216 5.32029 20.1283 10.3803 20.1283C15.4403 20.1283 19.547 16.0216 19.547 10.9616C19.547 5.90159 15.4403 1.79492 10.3803 1.79492ZM8.54696 15.5449L3.96362 10.9616L5.25612 9.66909L8.54696 12.9508L15.5045 5.99326L16.797 7.29492L8.54696 15.5449Z" fill="#333333"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.380371 0.961426)"></rect></clipPath></defs></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_MechanicalBreakdown_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container">
                    <adp-label labelKey="DeviceDetails_MechanicalBreakdown_Description"></adp-label>
                  </div>
                </div>
                <div class="coverage-section" *ngIf="hasLossTheftCoverage">
                  <h2 class="text-container" style="text-wrap: nowrap">
                    <div class="text-inner-container">
                      <mat-icon class="flavor-text-icon-sm"><ng-container *ngTemplateOutlet="theftLossIcon"></ng-container></mat-icon>
                      <!--<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M10.3803 1.79492C5.32029 1.79492 1.21362 5.90159 1.21362 10.9616C1.21362 16.0216 5.32029 20.1283 10.3803 20.1283C15.4403 20.1283 19.547 16.0216 19.547 10.9616C19.547 5.90159 15.4403 1.79492 10.3803 1.79492ZM8.54696 15.5449L3.96362 10.9616L5.25612 9.66909L8.54696 12.9508L15.5045 5.99326L16.797 7.29492L8.54696 15.5449Z" fill="#333333"></path></g><defs><clipPath id="clip0"><rect width="20" height="20" fill="white" transform="translate(0.380371 0.961426)"></rect></clipPath></defs></svg>-->
                    </div>
                    <adp-label labelKey="DeviceDetails_LossTheft_Heading"></adp-label>
                  </h2>
                  <div class="coverage-description-container">
                    <adp-label labelKey="DeviceDetails_LossTheft_Description"></adp-label>
                  </div>
                  <div class="coverage-description-disclaimer-container">
                    <div><ng-container *ngTemplateOutlet="infoIcon"></ng-container></div>
                    <adp-label labelKey="DeviceDetails_LossTheft_Disclaimer"></adp-label>
                  </div>
                </div>
              </div>
              <adp-setting key="DeviceDetails_ServiceFee_Enabled"></adp-setting>
              <div *ngIf="hasServiceFee" class="service-fee-label"><adp-label [labelKey]=serviceFeeLabelKey></adp-label></div>
              <adp-setting key="URL_DeviceDetailsClaims_Link"></adp-setting>
              <adp-setting key="URL_FileClaim"></adp-setting>
              <adp-setting key="URL_FileClaim_Prod"></adp-setting>
              <adp-setting key="DeviceDetails_FileClaimButtonEnabledPrimary"></adp-setting>
              <adp-setting key="DeviceDetails_FileClaimButtonEnabledSecondary"></adp-setting>
              <adp-setting key="DeviceDetails_SupportButtonEnabledPrimary"></adp-setting>
              <adp-setting key="DeviceDetails_SupportButtonEnabledSecondary"></adp-setting>
              <adp-setting key="DeviceDetails_ClaimsStatusButtonEnabledPrimary"></adp-setting>
              <adp-setting key="DeviceDetails_ClaimsStatusButtonEnabledSecondary"></adp-setting>
              <adp-setting key="Global_SupportCenter_Services_Enabled"></adp-setting>
              <adp-setting key="Global_DeviceDetails_Benefits_Enabled"></adp-setting>
              <div
                [ngClass]="isBenefitsSectionEnabled ? 'coverage-links-container container-with-benefits' : 'coverage-links-container'"
                *ngIf="isDeviceInInventory && !isSPOEEnabled">
                <div class="outer-link-container" ifSettingTrue="Global_SupportCenter_Services_Enabled">
                  <div *ngIf="showFileClaimButton" [ngClass]="showFileClaimButtonDivider ? 'toolsDivider' : ''" class="link-container">
                    <div class="icon-container">
                      <!--<mat-icon [svgIcon]="'action-view-list-blue'"></mat-icon>-->
                      <mat-icon
                        style="color: #3c4d6a; height: 24px; width: 24px; overflow: visible !important; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="fileClaimIcon"> </ng-container
                      ></mat-icon>
                    </div>
                    <div class="link-button-container">
                      <button
                        class="link"
                        style="vertical-align: sub"
                        (click)="handleFileClaim()"
                        [gtmClick]="getViewLabel('DeviceDetails_FileClaim_Button_Label')"
                        [gtmLinkURL]="resourceService.getPortalSetting('URL_DeviceDetailsClaims_Link')?.Value">
                        <adp-label labelKey="DeviceDetails_FileClaim_Button_Label"></adp-label>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="showSupportButton" [ngClass]="showSupportButtonDivider ? 'toolsDivider' : ''" class="link-container">
                    <div class="icon-container">
                      <mat-icon style="color: #3c4d6a; height: 24px; width: 24px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="supportIcon"> </ng-container
                      ></mat-icon>
                    </div>
                    <div class="link-button-container">
                      <button class="link" style="vertical-align: sub" (click)="handleChatWithLiveSupport()">
                        <adp-label labelKey="DeviceDetails_Support_Button_Label"></adp-label>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="showClaimsStatusButton" class="link-container">
                    <div class="icon-container">
                      <mat-icon style="color: #3c4d6a; height: 24px; width: 24px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="toolsIcon"> </ng-container
                      ></mat-icon>
                    </div>
                    <div class="link-button-container">
                      <button
                        class="link"
                        style="vertical-align: sub"
                        (click)="handleViewClaimStatus()"
                        [gtmClick]="getViewLabel('DeviceDetails_ClaimsStatus_Button_Label')"
                        [gtmLinkURL]="resourceService.getPortalSetting('URL_ClaimsPortal')?.Value">
                        <adp-label labelKey="DeviceDetails_ClaimsStatus_Button_Label"></adp-label>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="outer-link-container" ifSettingFalse="Global_SupportCenter_Services_Enabled">
                  <adp-label labelKey="Global_FileClaim_Subheading"></adp-label>
                </div>
              </div>
              <div
                [ngClass]="isBenefitsSectionEnabled ? 'coverage-links-container container-with-benefits' : 'coverage-links-container'"
                *ngIf="!isDeviceInInventory && !isSPOEEnabled">
                <div class="outer-link-container" ifSettingFalse="Global_SupportCenter_Services_Enabled">
                  <adp-label labelKey="Global_FileClaim_Subheading"></adp-label>
                </div>
              </div>
              <div *ngIf="isSPOEEnabled" class="coverage-links-container" style="margin-top:20px;">
                <div class="outer-link-container">
                  <div class="link-container">
                    <div class="icon-container">
                      <mat-icon
                        style="color: #3c4d6a; height: 32px; width: 32px; overflow: visible !important; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="coverageInfoIcon"> </ng-container
                      ></mat-icon>
                    </div>
                    <div class="link-button-container">
                      <button
                        class="link"
                        style="vertical-align: -webkit-baseline-middle"
                        (click)="handleViewP360HomeTechCoverageInformation()"
                        [gtmClick]="getViewLabel('DeviceDetails_FileClaim_Button_Label')"
                        [gtmLinkURL]="resourceService.getPortalSetting('URL_DeviceDetailsClaims_Link')?.Value">
                        <adp-label labelKey="DeviceDetails_ViewP360CoverageInfo_Button_Label"></adp-label>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div ifSettingTrue="Global_DeviceDetails_Benefits_Enabled">
                <div style="margin-top: 20px; display: flex">
                  <mat-tab-group>
                    <mat-tab [label]="tabTitleCoverageBenefits">
                      <ng-container *ngTemplateOutlet="CoverageBenefitsInfo"></ng-container>
                    </mat-tab>
                    <mat-tab [label]="tabTitleReimbursement">
                      <ng-container *ngTemplateOutlet="ReimbursementInfo"></ng-container>
                    </mat-tab>
                  </mat-tab-group>
                </div>
                <div style="margin-top: 40px">
                  <adp-label labelKey="CBR_Disclaimer_Text"></adp-label>
                </div>
              </div>
            </ng-container>
            <!-- Display when device is a smartphone (+M plan) and device hasn't been added to inventory yet -->
            <ng-container *ngIf="showPhoneGetStarted">
              <div class="phone-get-started-container">
                <div class="phone-get-started-header-section">
                  <h2 style="font-weight: 400; font-size: 20px">
                    <adp-label labelKey="DeviceDetails_PhoneGetStarted_Heading"></adp-label>
                  </h2>
                  <div class="phone-get-started-subheading">
                    <mat-icon style="overflow: visible !important"><ng-container *ngTemplateOutlet="warningIcon"></ng-container></mat-icon>
                    <div><adp-label labelKey="DeviceDetails_PhoneGetStarted_Subheading"></adp-label></div>
                  </div>
                </div>
                <div class="phone-get-started-coverage-section">
                  <h2 style="font-weight: 600; font-size: 18px">
                    <adp-label labelKey="DeviceDetails_PhoneGetStarted_CoverageList_Heading"></adp-label>
                  </h2>
                  <ul>
                    <ng-container *ngFor="let coverageItem of this.phonePreTestCoverageList">
                      <li>
                        <adp-label [labelKey]="coverageItem"></adp-label>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </ng-container>
            <!-- Display when there is NO coverage for the device -->
            <ng-container *ngIf="showNoCoverage">
              <h4 class="mb-4 no-coverage-header"><adp-label labelKey="DeviceDetails_NoCoverage_Heading"></adp-label></h4>

              <div fxLayout="row" fxLayoutAlign="start center" class="mb-4">
                <mat-icon class="flavor-text-icon-md mr-20" svgIcon="chat-icon"></mat-icon>
                <div><adp-label labelKey="DeviceDetails_SupportTopicsIntroText"></adp-label></div>
              </div>
              <adp-setting key="DeviceDetails_NoCoverage_SupportTopic_List"></adp-setting>
              <adp-setting key="DeviceDetails_SupportChatButtonEnabledPrimary"></adp-setting>
              <adp-setting key="DeviceDetails_SupportChatButtonEnabledSecondary"></adp-setting>
              <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="start start">
                <!-- column 1 -->
                <ul fxFlex="1 0 40%" fxLayout="column" fxLayoutAlign="start start" class="support-items-list">
                  <ng-container *ngFor="let supportTopic of this.noCoverageSupportTopicList; even as isEvenIndex">
                    <li *ngIf="isEvenIndex">
                      <adp-label [labelKey]="supportTopic"></adp-label>
                    </li>
                  </ng-container>
                </ul>

                <div fxFlex="0 0 48px" fxHide.lt-sm></div>

                <!-- column 2 -->
                <ul fxFlex="1 0 40%" fxLayout="column" fxLayoutAlign="start start" class="support-items-list">
                  <ng-container *ngFor="let supportTopic of this.noCoverageSupportTopicList; odd as isOddIndex">
                    <li *ngIf="isOddIndex">
                      <adp-label [labelKey]="supportTopic"></adp-label>
                    </li>
                  </ng-container>
                </ul>
              </div>

              <div *ngIf="showNoCoverageSupportChatButton" fxLayout="row" fxLayoutAlign="start start" fxLayoutAlign.lt-sm="center start">
                <button mat-stroked-button color="accent" class="no-coverage-support-button" (click)="handleChatWithLiveSupport()">
                  <adp-label labelKey="DeviceDetails_NoCoverage_SupportChat_Button_Label"></adp-label>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="showNoCoverageAndNoSupport">
              <div><adp-label labelKey="DeviceDetails_NoCoverage_NoSupport"></adp-label></div>
            </ng-container>
            <!-- Display when device is a tablet or smartwatch to determine if cellular-enabled or wifi and device hasn't been added to inventory yet -->
            <ng-container>
              <div>
                <!-- Display when there is SOME coverage for the device -->
                <ng-container *ngIf="showCellularGetStarted">
                  <div class="device-details-page-banner container" style="padding-left: 0px !important">
                    <adp-label labelKey="DeviceDetails_CoverageSection_Heading"></adp-label>
                  </div>
                  <div class="coverages-container">
                    <div style="display: flex">
                      <div>
                        <mat-icon style="writing-mode: vertical-rl; color: #e16d01; overflow: visible !important"
                          ><ng-container *ngTemplateOutlet="alertIcon"></ng-container
                        ></mat-icon>
                      </div>
                      <div style="margin-left: 10px">
                        <adp-label *ngIf="isTabletDevice" labelKey="DeviceDetails_CellularEnabled_Tablet_Heading"></adp-label>
                        <adp-label *ngIf="isSmartwatchDevice" labelKey="DeviceDetails_CellularEnabled_Smartwatch_Heading"></adp-label>
                      </div>
                    </div>
                    <div style="margin-top: 20px; font-size: 18px; font-weight: 600; color: #13223c">
                      <adp-label labelKey="DeviceDetails_CellularEnabled_Subheading"></adp-label>
                    </div>
                    <div style="margin-top: 15px; font-weight: 400; font-size: 16px; color: #3d515a">
                      <ul style="list-style-type: disc !important">
                        <ng-container *ngFor="let coverageItem of this.phonePreTestCoverageList">
                          <li style="color: #3d515a">
                            <adp-label [labelKey]="coverageItem"></adp-label>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </ng-container>

                <!-- Display when there is NO coverage for the device -->
                <ng-template #displayWhenNoCoverage>
                  <h4 class="mb-4 no-coverage-header" *ngIf="(deviceDetailsPage?.noCoverageHeading?.length ?? 0) > 0">
                    {{ deviceDetailsPage?.noCoverageHeading }}
                  </h4>

                  <div
                    *ngIf="deviceDetailsPage?.supportTopicsIntroText?.length > 0"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="mb-4">
                    <mat-icon class="flavor-text-icon-md mr-20" svgIcon="chat-icon"></mat-icon>
                    <div>{{ deviceDetailsPage?.supportTopicsIntroText }}</div>
                  </div>

                  <div
                    *ngIf="deviceDetailsPage?.supportTopicsList?.length > 0"
                    fxLayout="row wrap"
                    fxLayout.lt-sm="column"
                    fxLayoutAlign="start start">
                    <!-- column 1 -->
                    <ul fxFlex="1 0 40%" fxLayout="column" fxLayoutAlign="start start" class="support-items-list">
                      <ng-container *ngFor="let supportTopic of deviceDetailsPage?.supportTopicsList; even as isEvenIndex">
                        <li *ngIf="isEvenIndex">
                          {{ supportTopic.displayText }}
                        </li>
                      </ng-container>
                    </ul>

                    <div fxFlex="0 0 48px" fxHide.lt-sm></div>

                    <!-- column 2 -->
                    <ul fxFlex="1 0 40%" fxLayout="column" fxLayoutAlign="start start" class="support-items-list">
                      <ng-container *ngFor="let supportTopic of deviceDetailsPage?.supportTopicsList; odd as isOddIndex">
                        <li *ngIf="isOddIndex">
                          {{ supportTopic.displayText }}
                        </li>
                      </ng-container>
                    </ul>
                  </div>

                  <div
                    *ngIf="showNoCoverageSupportChatButton && deviceDetailsPage?.supportChatButtonText?.length > 0"
                    fxLayout="row"
                    fxLayoutAlign="start start"
                    fxLayoutAlign.lt-sm="center start">
                    <button mat-stroked-button color="accent" class="no-coverage-support-button" (click)="handleChatWithLiveSupport()">
                      {{ deviceDetailsPage?.supportChatButtonText }}
                    </button>
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <adp-setting key="Global_Devices_Manuals_Tips_Enabled"></adp-setting>
      <div ifSettingTrue="Global_Devices_Manuals_Tips_Enabled">
        <div style="display: flex !important; border: 1px solid #d6d6d6"></div>

        <div *ngIf="hasUserManualsContent">
          <ng-container *ngTemplateOutlet="UserManuals"></ng-container>
        </div>

        <div *ngIf="hasHowToGuidesContent || hasTipsandTricksContent">
          <ng-container *ngTemplateOutlet="DoMoreWithYourDevice"></ng-container>
        </div>

        <div *ngIf="!hasUserManualsContent && !hasHowToGuidesContent && !hasTipsandTricksContent">
          <div *ngIf="!hasSubmittedContentRequest; then NoContentRequest; else NoContentChat"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="viewTestResults">
      <div class="phone-details-wrapper">
        <div class="container device-details-page">
          <div class="row message-mobile-container">
            <div
              class="device-details-page-banner container"
              style="padding-top: 0px !important; margin-bottom: 25px; display: flex; flex-direction: column; gap: 8px">
              <span style="color: #13223c; font-weight: 600; font-size: 22.5px">
                <adp-label *ngIf="selDevice?.deviceTypeCode === 'SMPH'" labelKey="DeviceDetails_FailedTest_Smartphone_Heading"></adp-label>
                <adp-label *ngIf="selDevice?.deviceTypeCode === 'TABL'" labelKey="DeviceDetails_FailedTest_Tablet_Heading"></adp-label>
                <adp-label *ngIf="selDevice?.deviceTypeCode === 'SMAR'" labelKey="DeviceDetails_FailedTest_Smartwatch_Heading"></adp-label>
              </span>
              <span style="color: #3d515a; font-weight: 400; font-size: 16px">
                <adp-label
                  *ngIf="selDevice?.deviceTypeCode === 'SMPH'"
                  labelKey="DeviceDetails_FailedTest_Smartphone_SubHeading"></adp-label>
                <adp-label *ngIf="selDevice?.deviceTypeCode === 'TABL'" labelKey="DeviceDetails_FailedTest_Tablet_SubHeading"></adp-label>
                <adp-label
                  *ngIf="selDevice?.deviceTypeCode === 'SMAR'"
                  labelKey="DeviceDetails_FailedTest_Smartwatch_SubHeading"></adp-label>
              </span>
            </div>
          </div>
          <div class="row">
            <!-- DETAILS SECTION-->
            <div class="col-sm-4" style="border-right: 1px solid #d6d6d6; padding-right: 30px">
              <div class="adp-device-card" tabindex="0" cdkMonitorSubtreeFocus>
                <div class="device-card-container" [ngClass]="'noboxshadow'" style="background-color: white !important">
                  <div class="device-card-body">
                    <div class="ui-grid-grid-sm-12 ui-grid-item ui-grid">
                      <span>
                        <mat-icon
                          style="width: 100px !important; height: 100px !important; overflow: visible !important"
                          width="80"
                          height="80"
                          svgIcon="{{ deviceType?.imageKey }}"></mat-icon>
                      </span>
                    </div>
                    <div class="ui-grid-grid-sm-12 ui-grid-item device-card-row">
                      <ng-container *ngTemplateOutlet="InfoView"></ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- TEST SECTION-->
            <div class="col-sm-8" style="padding-left: 30px">
              <!-- BOTH TESTS FAILED -->
              <div class="coverages-container" *ngIf="crackScreenTestFailed && touchScreenTestFailed">
                <div class="coverage-title-test-results" *ngIf="crackScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="crackScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #b90000"><adp-label labelKey="DeviceDetails_FailedTest_CrackedScreen_Heading"></adp-label></span>
                  </h2>
                  <adp-setting key="DeviceDetails_CrackedScreenFailedTips_List"></adp-setting>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 600; font-size: 18px">
                      <adp-label labelKey="DeviceDetails_FailedTest_CrackedScreen_Tips_Heading"></adp-label>
                    </div>
                    <ul>
                      <li *ngFor="let listItem of this.crackScreenFailedTipsList">
                        <adp-label [labelKey]="listItem"></adp-label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="coverage-title-test-results" *ngIf="touchScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="touchScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #b90000"><adp-label labelKey="DeviceDetails_FailedTest_TouchScreen_Heading"></adp-label></span>
                  </h2>
                  <adp-setting key="DeviceDetails_TouchScreenFailedTips_List"></adp-setting>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 600; font-size: 18px">
                      <adp-label labelKey="DeviceDetails_FailedTest_TouchScreen_Tips_Heading"></adp-label>
                    </div>
                    <ul>
                      <li *ngFor="let listItem of this.touchScreenFailedTipsList">
                        <adp-label [labelKey]="listItem"></adp-label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- CRACK SCREEN PASSED / TOUCH SCREEN FAILED -->
              <div class="coverages-container" *ngIf="!crackScreenTestFailed && touchScreenTestFailed">
                <div class="coverage-title-test-results" *ngIf="touchScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="touchScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #b90000"><adp-label labelKey="DeviceDetails_FailedTest_TouchScreen_Heading"></adp-label></span>
                  </h2>
                  <adp-setting key="DeviceDetails_TouchScreenFailedTips_List"></adp-setting>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 600; font-size: 18px">
                      <adp-label labelKey="DeviceDetails_FailedTest_TouchScreen_Tips_Heading"></adp-label>
                    </div>
                    <ul>
                      <li *ngFor="let listItem of this.touchScreenFailedTipsList">
                        <adp-label [labelKey]="listItem"></adp-label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="coverage-title-test-results" *ngIf="!crackScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="crackScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #047d26"><adp-label labelKey="DeviceDetails_PassedTest_CrackedScreen_Heading"></adp-label></span>
                  </h2>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 400; font-size: 16px">
                      <adp-label labelKey="DeviceDetails_PassedTest_CrackedScreen_SubHeading"></adp-label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- TOUCH SCREEN PASSED / CRACK SCREEN FAILED -->
              <div class="coverages-container" *ngIf="crackScreenTestFailed && !touchScreenTestFailed">
                <div class="coverage-title-test-results" *ngIf="crackScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="crackScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #b90000"><adp-label labelKey="DeviceDetails_FailedTest_CrackedScreen_Heading"></adp-label></span>
                  </h2>
                  <adp-setting key="DeviceDetails_CrackedScreenFailedTips_List"></adp-setting>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 600; font-size: 18px">
                      <adp-label labelKey="DeviceDetails_FailedTest_CrackedScreen_Tips_Heading"></adp-label>
                    </div>
                    <ul>
                      <li *ngFor="let listItem of this.crackScreenFailedTipsList">
                        <adp-label [labelKey]="listItem"></adp-label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="coverage-title-test-results" *ngIf="!touchScreenTestFailed">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="touchScreenIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #047d26"><adp-label labelKey="DeviceDetails_PassedTest_TouchScreen_Heading"></adp-label></span>
                  </h2>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 400; font-size: 16px">
                      <adp-label labelKey="DeviceDetails_PassedTest_TouchScreen_SubHeading"></adp-label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TODO: Smartwatch test failure section -->
              <div class="coverages-container" *ngIf="frontOfWatchTestFailed || backOfWatchTestFailed">
                <div class="coverage-title-test-results coverage-title-test-results-smartwatch">
                  <h2 class="text-container">
                    <div class="text-inner-container">
                      <mat-icon style="color: #3c4d6a; width: 80px; overflow: visible !important"
                        ><ng-container *ngTemplateOutlet="cameraImageIcon"></ng-container
                      ></mat-icon>
                    </div>
                    <span style="color: #b90000"><adp-label labelKey="DeviceDetails_FailedTest_ImageUpload_Heading"></adp-label></span>
                  </h2>
                  <adp-setting key="DeviceDetails_ImageUploadFailedTips_List"></adp-setting>
                  <div class="coverage-description-container" style="margin-left: 90px">
                    <div style="font-weight: 600; font-size: 18px">
                      <adp-label labelKey="DeviceDetails_FailedTest_ImageUpload_Tips_Heading"></adp-label>
                    </div>
                    <ul>
                      <li *ngFor="let listItem of this.imageUploadFailedTipsList">
                        <adp-label [labelKey]="listItem"></adp-label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- RETAKE TEST BUTTON -->
              <div style="display: flex !important" class="retake-test-button-mobile-container">
                <div class="header-claims-status-link-container" style="display: flex !important; margin-top: 20px">
                  <div class="icon-container">
                    <button
                      mat-flat-button
                      color="accent"
                      style="min-width: 230px; font-size: 16px !important"
                      (click)="handleRetakeTest()"
                      [gtmClick]="getViewLabel('DeviceDetails_FailedTest_RetakeTest_Button_Label')">
                      <adp-label labelKey="DeviceDetails_FailedTest_RetakeTest_Button_Label"></adp-label>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="selDevice?.deviceTypeCode === 'SMPH'">
            <div class="device-details-page-banner container" style="margin-top: 50px !important; margin-bottom: 25px">
              <span style="color: #13223c; font-weight: 600; font-size: 22.5px"
                ><adp-label labelKey="DeviceDetails_PhonePartners_Heading"></adp-label></span
              ><br />
              <span style="color: #3d515a; font-weight: 400; font-size: 16px"
                ><adp-label labelKey="DeviceDetails_PhonePartners_SubHeading"></adp-label
              ></span>
            </div>
          </div>

          <div class="row" *ngIf="selDevice?.deviceTypeCode === 'SMPH'">
            <ng-container *ngTemplateOutlet="PhonePartners"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #CoverageBenefitsInfo>
    <div class="benefits-outer-container">
      <div style="display: flex" *ngFor="let item of coverageBenefitsList">
        <div class="benefits-icon-container">
          <adp-image [imageKey]="item.iconKey"></adp-image>
        </div>
        <div>
          <span style="font-weight: 600; color: #13223c"><adp-label [labelKey]="item.titleKey"></adp-label></span><br />
          <span style="font-weight: 400; color: #3d515a"><adp-label [labelKey]="item.bodyKey"></adp-label></span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #ReimbursementInfo>
    <div class="benefits-outer-container">
      <div style="display: flex" *ngFor="let item of reimbursementsList">
        <div class="benefits-icon-container">
          <adp-image [imageKey]="item.iconKey"></adp-image>
        </div>
        <div>
          <span style="font-weight: 600; color: #13223c"><adp-label [labelKey]="item.titleKey"></adp-label></span><br />
          <span style="font-weight: 400; color: #3d515a"><adp-label [labelKey]="item.bodyKey"></adp-label></span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #NoContentRequest>
    <div class="devices-no-content-container" *ngIf="selDevice && deviceManualsLoaded">
      <div class="device-details-no-content" style="text-align: center">
        <div style="color: 13223C !important; margin-top: 25px"><adp-label labelKey="DeviceDetails_NoContent_Heading"></adp-label></div>
        <div style="color: 3D515A !important; margin-top: 25px; font-weight: 400; font-size: 16px">
          <adp-label labelKey="DeviceDetails_NoContent_SubHeading"></adp-label>
        </div>
        <div
          style="
            margin: auto;
            margin-top: 25px;
            min-width: 225px !important;
            max-width: 225px !important;
            height: 28px !important;
            text-align: center;
          ">
          <button
            mat-flat-button
            color="accent"
            style="font-size: 16px !important"
            (click)="handleLetUsKnow()"
            [gtmClick]="getViewLabel('DeviceDetails_NoContent_Button_Label')">
            <adp-label labelKey="DeviceDetails_NoContent_Button_Label"></adp-label>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #NoContentChat>
    <div class="devices-no-content-container">
      <div class="device-details-no-content" style="text-align: center">
        <div style="color: 3D515A !important; margin-top: 25px; font-weight: 400; font-size: 16px">
          <adp-label labelKey="DeviceDetails_StillNeedHelp_Heading"></adp-label>
        </div>
        <div style="color: 13223C !important; margin-top: 25px">
          <adp-label labelKey="DeviceDetails_StillNeedHelp_SubHeading"></adp-label>
        </div>
        <div
          style="
            margin: auto;
            margin-top: 25px;
            min-width: 225px !important;
            max-width: 225px !important;
            height: 28px !important;
            text-align: center;
          ">
          <button mat-flat-button color="accent" style="font-size: 16px !important" (click)="handleChatWithLiveSupport()">
            <adp-label labelKey="DeviceDetails_StillNeedHelp_Button_Label"></adp-label>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #UserManuals>
    <div>
      <div
        class="device-details-page-banner container"
        style="margin-top: 20px !important; white-space: nowrap; margin: auto; text-align: center">
        <adp-label labelKey="DeviceDetails_UserManuals_Section_Heading"></adp-label>
      </div>
    </div>
    <div class="device-details-parent-container">
      <div>
        <div class="device-details-item-container" *ngFor="let userManual of userManualList">
          <a href="{{ userManual.url }}" target="_blank" [gtmClick]="userManual.title" [gtmLinkURL]="userManual.url">
            <div class="user-manual-card">
              <div class="user-manual-card_info">
                <div class="userManualIconContainer device-usermanual-theme">
                  <mat-icon style="height: 24px; width: 24px; overflow: visible !important">
                    <div *ngIf="userManual.subCategory == 'USER_GUIDE'"><ng-container *ngTemplateOutlet="USER_GUIDE"></ng-container></div>
                    <div *ngIf="userManual.subCategory == 'QUICK_START_GUIDE'">
                      <ng-container *ngTemplateOutlet="QUICK_START_GUIDE"></ng-container>
                    </div>
                    <div *ngIf="userManual.subCategory == 'ENERGY_GUIDE'">
                      <ng-container *ngTemplateOutlet="ENERGY_GUIDE"></ng-container>
                    </div>
                  </mat-icon>
                </div>
                <div class="user-manual-card_info-name">{{ userManual.title }}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #DoMoreWithYourDevice>
    <div *ngIf="hasHowToGuidesContent || hasTipsandTricksContent">
      <div
        class="device-details-page-banner container"
        style="margin-top: 20px !important; white-space: nowrap; margin: auto; text-align: center">
        <adp-label labelKey="DeviceDetails_DoMoreWithDevice_Section_Heading"></adp-label>
      </div>
    </div>
    <div class="tips-tricks-parent-container" style="margin-bottom: 50px" *ngIf="hasHowToGuidesContent || hasTipsandTricksContent">
      <div style="text-align: center">
        <div *ngIf="hasTipsandTricksContent" class="device-details-item-container">
          <div class="flex-container">
            <div class="flex-child">
              <adp-image imageKey="Global_DeviceDetails_TipsandTricks"></adp-image>
            </div>
            <div class="flex-child" style="text-align: left; font-size: 20px; color: #13223c; font-weight: 600; max-width: 275px">
              <adp-label labelKey="DeviceDetails_TipsAndTricks_Heading"></adp-label>
              <br /><span style="color: #3d515a; font-weight: 400 !important; font-size: 16px !important">
                <adp-label labelKey="DeviceDetails_TipsAndTricks_Description"></adp-label> </span
              ><br />
              <span class="view-link">
                <button
                  class="link"
                  style="vertical-align: sub"
                  (click)="handleViewTipsAndTricks()"
                  [gtmClick]="getViewLabel('DeviceDetails_TipsAndTricks_Link_Label')"
                  gtmLinkURL="/device-content/tips-and-tricks">
                  <adp-label labelKey="DeviceDetails_TipsAndTricks_Link_Label"></adp-label>
                </button>
                <!--<a href="#">View Tips and Tricks ></a>-->
              </span>
            </div>
          </div>
        </div>
        <div *ngIf="hasHowToGuidesContent" class="device-details-item-container">
          <div class="flex-container">
            <div class="flex-child">
              <adp-image imageKey="Global_DeviceDetails_HowToGuides"></adp-image>
            </div>
            <div class="flex-child" style="text-align: left; font-size: 20px; color: #13223c; font-weight: 600; max-width: 275px">
              <adp-label labelKey="DeviceDetails_HowToGuides_Heading"></adp-label>
              <br /><span style="color: #3d515a; font-weight: 400 !important; font-size: 16px !important">
                <adp-label labelKey="DeviceDetails_HowToGuides_Description"></adp-label> </span
              ><br />
              <span class="view-link"
                ><button
                  class="link"
                  style="vertical-align: sub"
                  (click)="handleViewHowToGuides()"
                  [gtmClick]="getViewLabel('DeviceDetails_HowToGuides_Link_Label')"
                  gtmLinkURL="/device-content/how-to-guides">
                  <adp-label labelKey="DeviceDetails_HowToGuides_Link_Label"></adp-label></button
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #InfoView>
    <div class="ui-grid-item ui-grid-grid-sm-12 device-card-row device-card-row-alt">
      <div class="ui-grid-grid-sm-12 ui-grid-item device-card-text">
        <div style="text-align: center">
          <div
            style="text-align: center; font-weight: 600; line-height: 28px; font-size: 18px; overflow: hidden"
            class="device-card-nickname-container">
            {{ selDevice | deviceDisplayName }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
      [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
      <div
        *ngIf="selDevice.deviceSource !== 'EPRISM' && selDevice?.nickName?.length > 0"
        style="margin-bottom: 15px; text-align: center; line-height: 28px; overflow: hidden"
        class="device-card-nickname-container nickname-theme-color">
        {{ selDevice?.nickName }}
      </div>
      <div *ngIf="selDevice.deviceSource === 'EPRISM'"
        style="margin-bottom: 15px; text-align: center; line-height: 28px; overflow: hidden"
        class="device-card-nickname-container nickname-theme-color">
        {{ formatPhoneNumber(selDevice?.phoneNumber) }}
      </div>
    </div>
    <div
      *ngIf="isMobileDevice"
      class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
      [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
      <div *ngIf="selDevice?.lineNumber?.length > 0" style="text-align: center; line-height: 28px" class="device-card-nickname-container">
        <!--<span style="font-weight:700;">Name: </span>-->{{ selDevice?.lineNumber }}
      </div>
    </div>
    <div
      *ngIf="isMobileDevice"
      class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
      [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
      <div
        *ngIf="selDevice?.imei?.length > 0"
        style="margin-bottom: 15px; text-align: center; line-height: 28px"
        class="device-card-nickname-container">
        <span style="font-weight: 600; color: #3d515a">
          <adp-label labelKey="DeviceDetails_InfoView_IMEI_Label"></adp-label>
        </span>
        {{ selDevice?.imei }}
      </div>
    </div>
    <div
      *ngIf="isTabletDevice || isSmartwatchDevice"
      class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
      [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
      <div
        *ngIf="selDevice?.imei?.length > 0"
        style="margin-bottom: 15px; text-align: center; line-height: 28px"
        class="device-card-nickname-container">
        <span style="font-weight: 600; color: #3d515a">
          <adp-label labelKey="DeviceDetails_InfoView_IMEI_Label"></adp-label>
        </span>
        {{ selDevice?.imei }}
      </div>
      <!-- If Tablet or Smart watch only show the IMEI and not the Serial number.  They are the same. -->
      <!-- <div
        *ngIf="selDevice?.serialNumber?.length > 0"
        style="margin-bottom: 15px; text-align: center; line-height: 28px"
        class="device-card-nickname-container">
        <span style="font-weight: 600; color: #3d515a">
          <adp-label labelKey="DeviceDetails_InfoView_SerialNumber_Label"></adp-label>
        </span>
        {{ selDevice?.serialNumber }}
      </div> -->
    </div>
    <div
      *ngIf="coverageBenefitsReimburementsEnabled"
      class="ui-grid-grid-sm-12 ui-grid-item device-card-text"
      [ngClass]="!title ? 'device-card-row-mobile-small' : 'device-card-row-mobile-large'">
      <div style="margin-bottom: 15px; text-align: center; line-height: 28px" class="device-card-nickname-container">
        <span style="font-weight: 600; color: #3d515a">
          <adp-label labelKey="DeviceDetails_InfoView_SerialNumber_Label"></adp-label>
        </span>
        {{ serialNumber }}
      </div>
    </div>
    <div *ngIf="isSPOEEnabled && !isAddDeviceEnabled && deviceContentLoaded" style="margin-top: 5px;justify-items: center;">
      <div style="width:75%; margin: 0 auto;">
        <button
          mat-flat-button
          color="accent"
          style="font-size: 16px !important"
          (click)="handleSPOEClaims()"
          [gtmClick]="getViewLabel('DeviceDetails_InfoView_Claims_Button_Label')"
        [gtmLinkURL]="this.selDevice.deviceSource === 'EPRISM' ? ' ' : this.resourceService.getPortalSetting('URL_DeviceDetailsClaims_Link')?.Value">
          <adp-label labelKey="DeviceDetails_InfoView_Claims_Button_Label"></adp-label>
        </button>
      </div>
      <div style="color:#3D515A;font-weight:400;font-size:14px;margin-top: 5px; text-align: center">
        <mat-icon style="color: #3c4d6a; height: 24px; width: 24px; overflow: visible !important; margin-top: 5px">
          <ng-container *ngTemplateOutlet="infoAddDeviceIcon"></ng-container>
        </mat-icon>
        <span style="margin-left: 3px">
          <adp-label labelKey="DeviceDetails_InfoView_Claims_Disclaimer_Text"></adp-label></span>
      </div>
    </div>
    <div *ngIf="isAddDeviceEnabled" style="margin-top: 5px;justify-items: center;">
      <div *ngIf="isSmartPhoneDevice && requireDiagnosticsOnDevice">
        <button
          mat-flat-button
          color="accent"
          style="font-size: 16px !important"
          (click)="handleStartRegisterPhoneNumber()"
          [gtmClick]="getViewLabel('DeviceDetails_InfoView_AddSmartPhone_Button_Label')">
          <adp-label labelKey="DeviceDetails_InfoView_AddSmartPhone_Button_Label"></adp-label>
        </button>
      </div>
      <div *ngIf="(isTabletDevice || isSmartwatchDevice) && requireDiagnosticsOnDevice" style="text-align: center">
        <!--<span style="text-align:center;"><adp-label labelKey="DeviceDetails_InfoView_AddCellularEnabled_Tag"></adp-label></span>-->
        <button
          mat-flat-button
          color="accent"
          style="font-size: 16px !important; margin-top: 16px"
          (click)="handleStartRegisterCellularEnabled()"
          [gtmClick]="getViewLabel('DeviceDetails_InfoView_AddCellularEnabled_Button_Label')">
          <adp-label labelKey="DeviceDetails_InfoView_AddCellularEnabled_Button_Label"></adp-label>
        </button>
      </div>
      <div *ngIf="!requireDiagnosticsOnDevice" [ngStyle]="{'width':(isSPOEEnabled)?'75%':'100%'}">
        <button
          mat-flat-button
          color="accent"
          style="font-size: 16px !important"
          (click)="showModal ? showAddDeviceModal() : handleAddDevice()"
          [gtmClick]="getViewLabel('DeviceDetails_InfoView_AddDevice_Button_Label')">
          <adp-label labelKey="DeviceDetails_InfoView_AddDevice_Button_Label"></adp-label>
        </button>
      </div>
      <div *ngIf="!requireDiagnosticsOnDevice" style="margin-top: 5px; text-align: center">
        <mat-icon style="color: #3c4d6a; height: 24px; width: 24px; overflow: visible !important; margin-top: 5px">
          <ng-container *ngTemplateOutlet="infoAddDeviceIcon"></ng-container>
        </mat-icon>
        <span style="margin-left: 3px"><adp-label labelKey="DeviceDetails_InfoView_AddDevice_Disclaimer_Text"></adp-label></span>
      </div>
    </div>
  </ng-template>

  <ng-template #PhonePartners>
    <div style="display: flex !important; padding: 0px !important">
      <div class="dashboard-container container" style="padding: 0px !important">
        <div class="row card-bottom-edge">
          <!-- CPR CELL PHONE REPAIR CARD -->
          <div class="col-lg-6 mobile-gap" style="display: flex; flex-grow: 1">
            <mat-card appearance="outlined" class="content-card">
              <mat-card-content style="width: 100%">
                <div style="display: flex !important; flex-direction: column; min-height: 100% !important">
                  <div style="display: flex !important">
                    <div class="icon-container">
                      <mat-icon
                        style="color: #3c4d6a; height: 40px; width: 40px; overflow: visible !important"
                        [svgIcon]="'cpr-logo'"></mat-icon>
                    </div>
                    <div class="status-link-container" style="padding-left: 15px; padding-top: 3px; font-size: 22.5px">
                      <adp-label labelKey="DeviceDetails_CellPhonRepair_Heading"></adp-label>
                    </div>
                  </div>
                  <div>
                    <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: end">
                      <div style="margin-top: 15px; font-size: 16px">
                        <adp-label labelKey="DeviceDetails_CellPhonRepair_Description"></adp-label>
                      </div>
                    </div>
                    <adp-setting key="URL_External_DeviceDetails_CellPhoneRepair"></adp-setting>
                    <div style="margin-top: 5px; min-width: 180px !important">
                      <a
                        href="{{ resourceService.getPortalSetting('URL_External_DeviceDetails_CellPhoneRepair')?.Value }}"
                        class="link"
                        style="font-weight: 400; font-size: 16px"
                        target="_blank"
                        [gtmClick]="getViewLabel('DeviceDetails_CellPhonRepair_Location_Link_Label')"
                        [gtmLinkURL]="resourceService.getPortalSetting('URL_External_DeviceDetails_CellPhoneRepair')?.Value"
                        ><adp-label labelKey="DeviceDetails_CellPhonRepair_Location_Link_Label"></adp-label
                      ></a>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <!-- BATTERIES PLUS CARD -->
          <ng-container>
            <div class="col-lg-6" style="display: flex; flex-grow: 1">
              <mat-card appearance="outlined" class="content-card" style="padding-bottom: 23px !important">
                <mat-card-content style="width: 100%">
                  <div style="display: flex !important; flex-direction: column; min-height: 100% !important">
                    <div style="display: flex !important">
                      <div class="icon-container">
                        <mat-icon
                          style="color: #3c4d6a; height: 40px; width: 162px; overflow: visible !important"
                          [svgIcon]="'bp-logo'"></mat-icon>
                      </div>
                      <!--<div class="status-link-container" style="padding-left:15px;padding-top:3px;font-size:22.5px;">
                    File a Claim
                  </div>-->
                    </div>
                    <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: end">
                      <div style="font-size: 16px">
                        <div style="margin-top: 15px">
                          <adp-label labelKey="DeviceDetails_BatteriesPlus_Description"></adp-label>
                        </div>
                      </div>
                      <adp-setting key="URL_External_DeviceDetails_Batteriesplus"></adp-setting>
                      <div style="margin-top: 5px; min-width: 180px !important">
                        <a
                          href="{{ resourceService.getPortalSetting('URL_External_DeviceDetails_Batteriesplus')?.Value }}"
                          target="_blank"
                          class="link"
                          style="font-weight: 400; font-size: 16px"
                          [gtmClick]="getViewLabel('DeviceDetails_BatteriesPlus_Link_Label')"
                          [gtmLinkURL]="resourceService.getPortalSetting('URL_External_DeviceDetails_Batteriesplus')?.Value"
                          ><adp-label labelKey="DeviceDetails_BatteriesPlus_Link_Label"></adp-label
                        ></a>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #removeDeviceIcon>
    <svg xmlns="http://www.w3.org/2000/svg" style="vertical-align: baseline" viewBox="0 0 24 24" height="24" width="24">
      <g>
        <line
          x1="1"
          y1="5"
          x2="23"
          y2="5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></line>
        <path
          d="M14.25,1H9.75a1.5,1.5,0,0,0-1.5,1.5V5h7.5V2.5A1.5,1.5,0,0,0,14.25,1Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
        <line
          x1="9.75"
          y1="17.75"
          x2="9.75"
          y2="10.25"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></line>
        <line
          x1="14.25"
          y1="17.75"
          x2="14.25"
          y2="10.25"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></line>
        <path
          d="M18.86,21.62A1.49,1.49,0,0,1,17.37,23H6.63a1.49,1.49,0,0,1-1.49-1.38L3.75,5h16.5Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
      </g>
    </svg>
  </ng-template>

  <ng-template #alertIcon>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.34666 20.3447C5.55332 20.446 5.78397 20.5 6.0153 20.5H18.9861C19.39 20.5 19.77 20.3427 20.0553 20.0573C20.342 19.772 20.5 19.3913 20.5 18.9867C20.5 18.7553 20.446 18.5247 20.3447 18.318L14.0296 5.45267C13.741 4.86467 13.1537 4.5 12.4977 4.5C12.2364 4.5 11.9844 4.55867 11.7484 4.67467C11.4124 4.84 11.1357 5.116 10.9704 5.45267L4.65602 18.3187C4.47736 18.6807 4.45136 19.092 4.58203 19.4747C4.71269 19.8573 4.98467 20.1667 5.34666 20.3447ZM12.1897 5.572C12.2864 5.524 12.391 5.5 12.4983 5.5C12.7663 5.5 13.0143 5.65467 13.1317 5.89333L19.448 18.76C19.4827 18.83 19.5007 18.908 19.5007 18.9867C19.5 19.124 19.4467 19.2527 19.3494 19.35C19.2521 19.4467 19.1234 19.5 18.9854 19.5H6.01396C5.93597 19.5 5.85797 19.482 5.78797 19.4473C5.53332 19.3227 5.42799 19.014 5.55332 18.7593L11.8684 5.89333C11.9364 5.75467 12.051 5.64 12.1897 5.572ZM12.5003 15.5C12.2244 15.5 12.0004 15.276 12.0004 15V9.99999C12.0004 9.72399 12.2244 9.49999 12.5003 9.49999C12.7757 9.49999 13.0003 9.72399 13.0003 9.99999V15C13.0003 15.2753 12.7757 15.5 12.5003 15.5ZM12.5004 18C12.0871 18 11.7504 17.6634 11.7504 17.25C11.7504 16.8367 12.0871 16.5 12.5004 16.5C12.9137 16.5 13.2504 16.8367 13.2504 17.25C13.2504 17.6634 12.9137 18 12.5004 18Z"
        fill="#E16D01" />
    </svg>
  </ng-template>

  <ng-template #infoIcon>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2585_54571)">
        <path
          d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z"
          fill="currentColor" />
        <path
          d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z"
          fill="currentColor" />
        <path
          d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z"
          fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2585_54571">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #mechanicalBreakdownIcon>
    <!--<svg xmlns="http://www.w3.org/2000/svg" style="vertical-align:baseline;" viewBox="0 0 24 24" height="21" width="21"><defs></defs><title>check-circle</title><path d="M6.75,9l3.294,4.611a1.526,1.526,0,0,0,2.414.09L23.25.749" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M16.783,3.824A10.487,10.487,0,1,0,20.8,8.377" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path></svg>-->

    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_685_170922)">
        <path
          d="M17.5878 2.47473C15.1955 1.43048 12.6106 0.899612 10.0003 0.916402C7.39144 0.900195 4.80811 1.43105 2.41701 2.47473C2.19234 2.5767 2.00198 2.74151 1.8689 2.94926C1.73582 3.15702 1.6657 3.39885 1.66701 3.64557V10.0097C1.66689 12.0796 2.29411 14.1009 3.46595 15.8071C4.63779 17.5133 6.29922 18.8243 8.23118 19.5672L9.12618 19.9122C9.68742 20.1393 10.3149 20.1393 10.8762 19.9122L11.7712 19.5672C13.7028 18.8241 15.3639 17.5129 16.5354 15.8068C17.707 14.1006 18.3339 12.0794 18.3337 10.0097V3.64557C18.3353 3.3993 18.2658 3.1578 18.1335 2.95009C18.0012 2.74238 17.8117 2.57731 17.5878 2.47473V2.47473Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M15.1938 12.6723L6.41211 3.89062" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.16699 6.02148L13.307 15.1615" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M15.3145 4.49958C13.6373 3.7743 11.8276 3.4054 10.0003 3.41625C8.17304 3.4054 6.36341 3.7743 4.68618 4.49958C4.53041 4.57086 4.39855 4.68562 4.30645 4.83005C4.21434 4.97449 4.16593 5.14245 4.16701 5.31375V9.74125C4.17432 11.1844 4.61775 12.5916 5.43911 13.7782C6.26047 14.9648 7.42139 15.8754 8.76951 16.3904L9.39201 16.6304C9.78221 16.7882 10.2185 16.7882 10.6087 16.6304L11.2312 16.3904C12.5793 15.8754 13.7402 14.9648 14.5616 13.7782C15.3829 12.5916 15.8264 11.1844 15.8337 9.74125V5.31375C15.8348 5.14245 15.7863 4.97449 15.6942 4.83005C15.6021 4.68562 15.4703 4.57086 15.3145 4.49958V4.49958Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_685_170922">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #accidentalDamageIcon>
    <!--<svg xmlns="http://www.w3.org/2000/svg" style="vertical-align:baseline;" viewBox="0 0 24 24" height="21" width="21"><defs></defs><title>protection-shield-1</title><path d="M2.25,3.923v7.614A11.907,11.907,0,0,0,9.882,22.65l1.041.4a3,3,0,0,0,2.154,0l1.041-.4A11.907,11.907,0,0,0,21.75,11.537V3.923a1.487,1.487,0,0,0-.868-1.362A21.7,21.7,0,0,0,12,.75,21.7,21.7,0,0,0,3.118,2.561,1.487,1.487,0,0,0,2.25,3.923Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><line x1="8.715" y1="18.316" x2="18.75" y2="8.281" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line><line x1="17.145" y1="4.588" x2="6.221" y2="15.507" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line><path d="M5.25,5.916v5.8a8.214,8.214,0,0,0,5.3,7.586l.711.274a2.047,2.047,0,0,0,1.47,0l.711-.274a8.214,8.214,0,0,0,5.3-7.586v-5.8a1.016,1.016,0,0,0-.592-.93A15.381,15.381,0,0,0,12,3.75,15.381,15.381,0,0,0,5.842,4.986,1.016,1.016,0,0,0,5.25,5.916Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path></svg>-->
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" height="25" width="24">
      <g clip-path="url(#clip0_685_170756)">
        <path d="M3 11H0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.5 8L0.5 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.5 14L0.5 16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21 11H23.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21.5 8L23.5 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21.5 14L23.5 16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.4961 20H5.49609" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M18.5 9.5V3C18.5 2.46957 18.2893 1.96086 17.9142 1.58579C17.5391 1.21071 17.0304 1 16.5 1H7.5C6.96957 1 6.46086 1.21071 6.08579 1.58579C5.71071 1.96086 5.5 2.46957 5.5 3V10H9.5L13.5 7L18.5 9.5Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M5.5 13V22C5.5 22.5304 5.71071 23.0391 6.08579 23.4142C6.46086 23.7893 6.96957 24 7.5 24H16.5C17.0304 24 17.5391 23.7893 17.9142 23.4142C18.2893 23.0391 18.5 22.5304 18.5 22V12.5L13.5 10L9.5 13H5.5Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M11.9961 22.25C11.858 22.25 11.7461 22.1381 11.7461 22C11.7461 21.8619 11.858 21.75 11.9961 21.75" stroke="currentColor" />
        <path
          d="M11.9961 22.25C12.1341 22.25 12.2461 22.1381 12.2461 22C12.2461 21.8619 12.1341 21.75 11.9961 21.75"
          stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_685_170756">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>
  <ng-template #theftLossIcon>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" height="25" width="24">
      <defs></defs>
      <title>crime-man-thief-1</title>
      <path d="M13.5,11.5a2.5,2.5,0,0,0-3,0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      <path
        d="M18,6.5a6,6,0,0,0-12,0v2a6,6,0,0,0,12,0Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <path
        d="M17.809,10c-1.3.022-3.63.2-5.442-1.6a.513.513,0,0,0-.734,0C9.821,10.2,7.487,10.024,6.191,10"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <line
        x1="6.084"
        y1="5.5"
        x2="17.916"
        y2="5.5"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></line>
      <path
        d="M23,23.5V20.394a1.98,1.98,0,0,0-.77-1.58A14.775,14.775,0,0,0,15,16.178"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <path
        d="M9,16.178a14.775,14.775,0,0,0-7.23,2.636A1.98,1.98,0,0,0,1,20.394V23.5"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <path
        d="M9,13.7v2.8a6.338,6.338,0,0,0,3,1,6.338,6.338,0,0,0,3-1V13.7"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <line x1="11" y1="17.369" x2="11" y2="14.417" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="13" y1="17.369" x2="13" y2="14.417" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="10" y1="3" x2="10" y2="0.842" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="14" y1="3" x2="14" y2="0.842" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="12" y1="2.5" x2="12" y2="0.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="8.5" y1="7.5" x2="9.5" y2="7.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
      <line x1="15.5" y1="7.5" x2="14.5" y2="7.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
    </svg>
  </ng-template>
  <ng-template #tabletIcon>
    <svg width="80" height="80" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="32" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.0743 8.00171H42.9257C44.8839 8.02239 45.8804 8.23341 46.9137 8.78602C47.9028 9.31498 48.685 10.0972 49.214 11.0863C49.7666 12.1196 49.9776 13.1161 49.9983 15.0743L50 15.4097V48.5903C50 50.7733 49.7973 51.823 49.214 52.9137C48.685 53.9028 47.9028 54.685 46.9137 55.214C45.8804 55.7666 44.8839 55.9776 42.9257 55.9983L42.5903 56H21.4097C19.2267 56 18.177 55.7973 17.0863 55.214C16.0972 54.685 15.315 53.9028 14.786 52.9137C14.2334 51.8804 14.0224 50.8839 14.0017 48.9257V15.0743C14.0224 13.1161 14.2334 12.1196 14.786 11.0863C15.315 10.0972 16.0972 9.31498 17.0863 8.78602C18.1196 8.23341 19.1161 8.02239 21.0743 8.00171ZM42.7841 10.0005L21.4097 10L20.8523 10.0049L20.5996 10.0111L20.1409 10.0318C19.1387 10.0933 18.5905 10.2496 18.0295 10.5496C17.3889 10.8922 16.8922 11.3889 16.5496 12.0295C16.2529 12.5843 16.0968 13.1266 16.0339 14.108L16.0201 14.3628L16.0049 14.8523L16 15.4097V48.5903L16.0049 49.1477L16.0111 49.4004L16.0318 49.8591C16.0933 50.8613 16.2496 51.4095 16.5496 51.9705C16.8922 52.6111 17.3889 53.1078 18.0295 53.4504C18.5843 53.7471 19.1266 53.9032 20.108 53.9661L20.3628 53.9799L20.8523 53.9951L21.4097 54H42.5903L43.1477 53.9951L43.4004 53.9889L43.8591 53.9682C44.8613 53.9067 45.4095 53.7504 45.9705 53.4504C46.6111 53.1078 47.1078 52.6111 47.4504 51.9705C47.7471 51.4157 47.9032 50.8734 47.9661 49.892L47.9799 49.6372L47.9951 49.1477L48 48.5903V15.4097L47.9951 14.8523L47.9889 14.5996L47.9682 14.1409C47.9067 13.1387 47.7504 12.5905 47.4504 12.0295C47.1078 11.3889 46.6111 10.8922 45.9705 10.5496C45.4157 10.2529 44.8734 10.0968 43.892 10.0339L43.6372 10.0201L43.1477 10.0049L42.7841 10.0005ZM44.4484 12.3853C43.9134 12.0992 43.3999 12 42.4361 12H21.5639L21.332 12.0021C20.5144 12.0178 20.042 12.123 19.5516 12.3853C19.0514 12.6528 18.6528 13.0514 18.3853 13.5516C18.0992 14.0866 18 14.6001 18 15.5639V48.4361L18.0021 48.668C18.0178 49.4856 18.123 49.958 18.3853 50.4484C18.6528 50.9486 19.0514 51.3472 19.5516 51.6147C20.0866 51.9008 20.6001 52 21.5639 52H42.4361L42.6679 51.9979C43.4856 51.9822 43.958 51.877 44.4484 51.6147C44.9486 51.3472 45.3472 50.9486 45.6147 50.4484C45.9008 49.9134 46 49.3999 46 48.4361V15.5639L45.9979 15.332C45.9822 14.5144 45.877 14.042 45.6147 13.5516C45.3472 13.0514 44.9486 12.6528 44.4484 12.3853ZM42.6056 14.001H21.3944L21.0891 14.0108C20.7836 14.0289 20.6402 14.0711 20.4948 14.1489C20.3431 14.2301 20.2301 14.3431 20.1489 14.4948C20.1114 14.5649 20.0822 14.6345 20.0599 14.7221L20.04 14.8163L20.017 15.0021L20.0093 15.1157L20.001 15.3944V48.6056L20.0108 48.9109C20.0289 49.2164 20.0711 49.3598 20.1489 49.5052C20.2301 49.6569 20.3431 49.7699 20.4948 49.8511C20.5649 49.8886 20.6345 49.9178 20.7221 49.9401L20.8163 49.96L21.0021 49.983L21.1157 49.9907L21.3944 49.999H42.6056L42.943 49.9871L42.9979 49.983L43.1837 49.96C43.3191 49.9364 43.4117 49.9011 43.5052 49.8511C43.6569 49.7699 43.7699 49.6569 43.8511 49.5052C43.8886 49.4351 43.9178 49.3655 43.9401 49.2779L43.96 49.1837L43.983 48.9979L43.9907 48.8843L43.999 48.6056V15.3944L43.9871 15.057L43.983 15.0021L43.96 14.8163C43.9364 14.6809 43.9011 14.5883 43.8511 14.4948C43.7699 14.3431 43.6569 14.2301 43.5052 14.1489C43.4351 14.1114 43.3655 14.0822 43.2779 14.0599L43.1837 14.04L42.9979 14.017L42.8843 14.0093L42.6056 14.001ZM39 47C39 46.4477 38.5523 46 38 46H26L25.8834 46.0067C25.386 46.0645 25 46.4872 25 47C25 47.5523 25.4477 48 26 48H38L38.1166 47.9933C38.614 47.9355 39 47.5128 39 47Z"
        fill="currentColor" />
    </svg>
  </ng-template>

  <ng-template #cameraImageIcon>
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="80" rx="40" fill="#F2F2F2" />
      <path
        d="M54.5611 36.413C56.0339 36.413 57.2278 35.2546 57.2278 33.8256C57.2278 32.3967 56.0339 31.2383 54.5611 31.2383C53.0884 31.2383 51.8945 32.3967 51.8945 33.8256C51.8945 35.2546 53.0884 36.413 54.5611 36.413Z"
        fill="#3C4D6A" />
      <path
        d="M38.7818 29.4023C32.2361 29.4023 26.9102 34.57 26.9102 40.9212C26.9102 47.2724 32.2361 52.44 38.7818 52.44C45.3275 52.44 50.6535 47.2724 50.6535 40.9212C50.6462 34.5771 45.3202 29.4104 38.7818 29.4023ZM38.7818 49.6919C33.7965 49.6919 29.7424 45.7573 29.7424 40.9212C29.7424 36.085 33.7975 32.1504 38.7818 32.1504C43.7661 32.1504 47.8212 36.085 47.8212 40.9212C47.816 45.7513 43.7598 49.6869 38.7818 49.6919Z"
        fill="#3C4D6A" />
      <path
        d="M55.9993 26.4684H52.741C51.9879 26.4684 51.3119 26.0611 50.9775 25.4062L49.4848 22.5126C48.6931 20.9632 47.0942 20 45.3109 20H32.7299C30.9466 20 29.3477 20.9632 28.555 22.5146L27.056 25.4052C26.7217 26.0601 26.0467 26.4674 25.2936 26.4684H22.0416C18.7052 26.4684 16 29.0932 16 32.3304V52.3421C16 55.5793 18.7052 58.2041 22.0416 58.2041H57.3451C58.093 58.2041 58.6992 57.6159 58.6992 56.8902C58.6992 56.5273 58.5471 56.1989 58.3023 55.9614C58.0576 55.7239 57.719 55.5763 57.3451 55.5763H22.0416C20.201 55.5763 18.7083 54.128 18.7083 52.3421V32.3304C18.7083 30.5445 20.201 29.0962 22.0416 29.0962H25.3113C27.0946 29.0962 28.6935 28.133 29.4862 26.5816L30.9851 23.691C31.3195 23.0361 31.9945 22.6288 32.7476 22.6278H45.2995C46.0526 22.6278 46.7286 23.0351 47.063 23.69L48.5557 26.5836C49.3473 28.133 50.9462 29.0962 52.7295 29.0962H55.9993C57.8399 29.0962 59.3325 30.5445 59.3325 32.3304V49.596C59.3325 50.3217 59.9388 50.9099 60.6867 50.9099C61.0606 50.9099 61.3992 50.7624 61.644 50.5249C61.8887 50.2873 62.0408 49.9589 62.0408 49.596V32.3304C62.0408 29.0932 59.3357 26.4684 55.9993 26.4684Z"
        fill="#3C4D6A" />
    </svg>
  </ng-template>

  <ng-template #crackScreenIcon>
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="80" rx="40" fill="#F2F2F2" />
      <g clip-path="url(#clip0_2527_23145)">
        <path d="M53 55H27" stroke="#3C4D6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M49 17H31C28.7909 17 27 18.7909 27 21V59C27 61.2092 28.7909 63 31 63H49C51.2092 63 53 61.2092 53 59V21C53 18.7909 51.2092 17 49 17Z"
          stroke="#3C4D6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M40 59.5C39.7238 59.5 39.5 59.2762 39.5 59C39.5 58.7238 39.7238 58.5 40 58.5" stroke="#3C4D6A" stroke-width="2" />
        <path d="M40 59.5C40.2762 59.5 40.5 59.2762 40.5 59C40.5 58.7238 40.2762 58.5 40 58.5" stroke="#3C4D6A" stroke-width="2" />
        <path
          d="M44.5 16.75L38.9448 22.3052C38.7876 22.462 38.6629 22.6482 38.5778 22.8532C38.4928 23.0583 38.449 23.278 38.449 23.5C38.449 23.722 38.4928 23.9417 38.5778 24.1468C38.6629 24.3518 38.7876 24.538 38.9448 24.6947L43.3053 29.0552C43.4624 29.212 43.5871 29.3982 43.6722 29.6032C43.7572 29.8083 43.801 30.028 43.801 30.25C43.801 30.472 43.7572 30.6917 43.6722 30.8968C43.5871 31.1018 43.4624 31.288 43.3053 31.4447L37.75 37"
          stroke="#3C4D6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2527_23145">
          <rect width="48" height="48" fill="white" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #touchScreenIcon>
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="80" rx="40" fill="#F2F2F2" />
      <g clip-path="url(#clip0_2527_23131)">
        <path
          d="M44.7496 40.9048C47.02 39.454 48.7589 37.3062 49.7054 34.7835C50.6519 32.2609 50.755 29.4993 49.9992 26.9131C49.2435 24.3269 47.6696 22.0554 45.5137 20.4393C43.3578 18.8233 40.736 17.9497 38.0416 17.9497C35.3473 17.9497 32.7255 18.8233 30.5696 20.4393C28.4137 22.0554 26.8398 24.3269 26.0841 26.9131C25.3283 29.4993 25.4314 32.2609 26.3779 34.7835C27.3244 37.3062 29.0633 39.454 31.3337 40.9048"
          stroke="#3C4D6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M33.5494 62.0404L26.253 53.2645C25.7648 52.6782 25.5295 51.9219 25.5988 51.1621C25.6682 50.4023 26.0366 49.7011 26.6229 49.2129C27.2092 48.7246 27.9655 48.4893 28.7253 48.5587C29.4851 48.6281 30.1863 48.9964 30.6745 49.5828L35.1669 54.999V36.1668C35.1669 35.4044 35.4698 34.6732 36.009 34.134C36.5481 33.5949 37.2793 33.292 38.0418 33.292C38.8042 33.292 39.5355 33.5949 40.0746 34.134C40.6137 34.6732 40.9166 35.4044 40.9166 36.1668V48.6245H46.6663C48.6995 48.6245 50.6495 49.4322 52.0872 50.8699C53.5249 52.3076 54.3326 54.2575 54.3326 56.2907V62.0404"
          stroke="#3C4D6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2527_23131">
          <rect width="48" height="48" fill="white" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #infoAddDeviceIcon>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z"
        fill="currentColor" />
      <path
        d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z"
        fill="currentColor" />
      <path
        d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z"
        fill="currentColor" />
    </svg>
  </ng-template>

  <ng-template #coverageInfoIcon>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.86811 5.27274C7.39566 5.36698 6.9893 5.58593 6.65694 5.92531C6.33786 6.25114 6.15032 6.59405 6.04441 7.0453C6.00191 7.22638 6 7.67954 6 17.5035C6 27.3274 6.00191 27.7806 6.04441 27.9617C6.15032 28.4129 6.33786 28.7558 6.65694 29.0817C6.94717 29.378 7.32421 29.5969 7.72989 29.7046L7.93846 29.7599H17.4958H27.0531L27.2617 29.7046C27.6673 29.5969 28.0444 29.3781 28.3347 29.0817C28.6449 28.7649 28.8197 28.4509 28.9473 27.981C28.9882 27.8302 28.991 27.3451 28.9981 19.1107C29.0034 12.935 28.9978 10.3402 28.9789 10.1947C28.9264 9.79094 28.7771 9.4257 28.5316 9.10031C28.3419 8.84885 25.2013 5.78694 24.9869 5.6444C24.7608 5.49409 24.4979 5.37121 24.2558 5.30265L24.0595 5.24705L16.0481 5.2431C9.35154 5.23978 8.00895 5.24464 7.86811 5.27274ZM8.07327 6.80355C7.88735 6.86011 7.69556 7.02878 7.60261 7.21752L7.54586 7.33273V17.5035V27.6743L7.60301 27.7903C7.68398 27.9547 7.85832 28.1176 8.01663 28.1769C8.14837 28.2262 8.18354 28.2263 17.4958 28.2263C26.808 28.2263 26.8432 28.2262 26.9749 28.1769C27.1333 28.1176 27.3076 27.9547 27.3886 27.7903L27.4457 27.6743L27.4531 19.0493C27.4586 12.7389 27.4532 10.3899 27.433 10.2958C27.4158 10.2155 27.3715 10.1231 27.3152 10.05C27.2655 9.98552 26.7501 9.46962 26.1698 8.90349C25.5895 8.33736 24.888 7.65196 24.6111 7.38033C24.1669 6.94472 24.0908 6.88023 23.966 6.83356L23.8246 6.78063L15.9797 6.78275C11.665 6.7839 8.10708 6.79327 8.07327 6.80355ZM11.2384 12.9237C11.07 12.96 10.9493 13.0334 10.8242 13.1756C10.7013 13.3152 10.6498 13.4662 10.6501 13.6862C10.6503 13.8179 10.6646 13.8904 10.7097 13.9873C10.7883 14.1559 10.9676 14.325 11.1339 14.3872C11.2654 14.4364 11.302 14.4367 17.577 14.4304L23.8878 14.424L24.0071 14.3631C24.1692 14.2803 24.3517 14.0758 24.404 13.9182C24.466 13.7316 24.4446 13.4784 24.3526 13.3094C24.2323 13.0883 24.0421 12.9562 23.7831 12.9138C23.5609 12.8774 11.4087 12.887 11.2384 12.9237ZM11.1265 17.5539C10.9676 17.6151 10.7859 17.7889 10.7097 17.9525C10.6646 18.0494 10.6503 18.1219 10.6501 18.2537C10.6498 18.4744 10.7013 18.6247 10.8259 18.7662C10.9566 18.9147 11.0938 18.9913 11.2878 19.0241C11.4016 19.0434 13.2219 19.0491 17.643 19.0441L23.8387 19.0371L23.9748 18.9733C24.2639 18.8376 24.4154 18.6238 24.4346 18.3242C24.4498 18.087 24.3978 17.9345 24.2443 17.7666C24.1795 17.6957 24.0727 17.6102 24.0071 17.5767L23.8878 17.5158L17.5694 17.5108C11.3498 17.5059 11.2491 17.5066 11.1265 17.5539ZM11.2384 22.1253C11.07 22.1615 10.9493 22.2349 10.8242 22.3771C10.7013 22.5167 10.6498 22.6677 10.6501 22.8877C10.6503 23.0194 10.6646 23.0919 10.7097 23.1888C10.7884 23.3577 10.9675 23.5265 11.1344 23.5889C11.2654 23.6379 11.307 23.6385 14.5102 23.6321L17.7534 23.6256L17.8728 23.5646C18.0348 23.4818 18.2173 23.2773 18.2697 23.1197C18.3316 22.9332 18.3102 22.6799 18.2183 22.5109C18.0979 22.2898 17.9077 22.1578 17.6487 22.1153C17.4295 22.0794 11.4078 22.0888 11.2384 22.1253Z" fill="currentColor"/>
    </svg>
  </ng-template>

  <ng-template #fileClaimIcon>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <defs></defs>
      <title>folder-file-1</title>
      <path
        d="M23.231,12.435a1,1,0,0,0-.979-1.193H10.424a1,1,0,0,1-.978-.8L9.168,9.051a1,1,0,0,0-.978-.8H1.747A1,1,0,0,0,.769,9.444l2.593,13a1,1,0,0,0,.978.8H20.258a1,1,0,0,0,.978-.8C21.647,20.392,22.744,14.869,23.231,12.435Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M4.5,5.25l.02-3.5a1,1,0,0,1,1-1H18.483a1,1,0,0,1,1,1l.02,6.5"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <line
        x1="7.512"
        y1="3.742"
        x2="15.75"
        y2="3.75"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></line>
      <line
        x1="12"
        y1="6.75"
        x2="15.75"
        y2="6.75"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></line>
    </svg>
  </ng-template>

  <ng-template #supportIcon>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <defs></defs>
      <title>meeting-headphones</title>
      <path
        d="M4.5,18.011H3.75a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3H4.5c.414,0,1.5.336,1.5.75v7.5C6,17.675,4.914,18.011,4.5,18.011Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M20.25,18.011H19.5c-.414,0-1.5-.336-1.5-.75v-7.5c0-.414,1.086-.75,1.5-.75h.75a3,3,0,0,1,3,3v3A3,3,0,0,1,20.25,18.011Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M3.75,9.011A8.25,8.25,0,0,1,12,.761h0a8.25,8.25,0,0,1,8.25,8.25"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M15,21.761h2.25a3,3,0,0,0,3-3h0v-.75"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M13.5,23.261h-3a1.5,1.5,0,0,1-1.5-1.5H9a1.5,1.5,0,0,1,1.5-1.5h3a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,13.5,23.261Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
    </svg>
  </ng-template>

  <ng-template #toolsIcon>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <title>tools-wrench-screwdriver</title>
      <g>
        <g>
          <path
            d="M3.06 23.06a1.5 1.5 0 0 1-2.12-2.12l6.57-6.57 2.12 2.12Z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m6.45 13.31 4.24 4.24"></path>
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m18.51 5.51-9.94 9.92"></path>
          <path
            d="M20.71 6.1a1 1 0 0 1-.73.39 1 1 0 0 1-.78-.29l-1.41-1.41A1 1 0 0 1 17.5 4a1 1 0 0 1 .43-.73L21.82.59a.5.5 0 0 1 .64.06l.89.89a.5.5 0 0 1 0 .66Z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        </g>
        <path
          d="M13 11 8.15 6.15A4.13 4.13 0 0 0 8.5 4.5a4 4 0 0 0-4-4 4.38 4.38 0 0 0-.82.08.5.5 0 0 0-.38.35.51.51 0 0 0 .13.5l1.42 1.42a.49.49 0 0 1 .15.36V4.5a.5.5 0 0 1-.5.5H3.21a.49.49 0 0 1-.36-.15L1.43 3.43a.51.51 0 0 0-.5-.13.52.52 0 0 0-.35.38 4.38 4.38 0 0 0-.08.82 4 4 0 0 0 4 4 4.13 4.13 0 0 0 1.65-.35L11 13"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
        <path
          d="m14.56 12.56 3.29 3.29a4.13 4.13 0 0 1 1.65-.35 4 4 0 0 1 4 4 4.38 4.38 0 0 1-.08.82.5.5 0 0 1-.35.38.51.51 0 0 1-.5-.13l-1.42-1.42a.49.49 0 0 0-.36-.15H19.5a.5.5 0 0 0-.5.5v1.29a.49.49 0 0 0 .15.36l1.42 1.42a.51.51 0 0 1 .13.5.52.52 0 0 1-.38.35 4.38 4.38 0 0 1-.82.08 4 4 0 0 1-4-4 4.13 4.13 0 0 1 .35-1.65l-3.3-3.3"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
      </g>
    </svg>
  </ng-template>

  <ng-template #QUICK_START_GUIDE>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <defs></defs>
      <title>book-bookmark</title>
      <path
        d="M20.959,10.5l-2-2-2,2v-8a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <path
        d="M15,3c-2,0-3,1.5-3,3.5C12,4.5,11,3,9,3H2A1,1,0,0,0,1,4V18a1,1,0,0,0,1,1H9a2.652,2.652,0,0,1,3,3,2.652,2.652,0,0,1,3-3h7a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H21"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <line
        x1="12"
        y1="6.5"
        x2="12"
        y2="21.5"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></line>
    </svg>
  </ng-template>

  <ng-template #USER_GUIDE>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <defs></defs>
      <title>single-neutral-book</title>
      <path
        d="M20,.5H4.5a1.5,1.5,0,0,0,0,3h16A.5.5,0,0,1,21,4V23a.5.5,0,0,1-.5.5H5a2,2,0,0,1-2-2V2"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5px"></path>
      <g id="_Group_" data-name="&lt;Group&gt;">
        <path
          d="M17.5,19.22s-2.02-.893-3.432-1.415c-.926-.345-.794-1.907-.258-2.494a4.285,4.285,0,0,0,1.259-3.532A3,3,0,0,0,12,8.5a3,3,0,0,0-3.069,3.279,4.285,4.285,0,0,0,1.259,3.532c.536.587.668,2.149-.258,2.494C8.52,18.327,6.5,19.22,6.5,19.22"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
      </g>
    </svg>
  </ng-template>

  <ng-template #ENERGY_GUIDE>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
      <g>
        <rect
          x="7.5"
          y="6.53"
          width="9"
          height="13"
          rx="2"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></rect>
        <path
          d="M10.5,6.53v-1a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
        <path
          d="M.77,14.53A11.5,11.5,0,1,1,23.5,12a11.4,11.4,0,0,1-.27,2.5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
        <g>
          <path
            d="M22.47,16.8a12,12,0,0,1-1.25,2.09"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
          <path
            d="M19.65,20.61a12,12,0,0,1-2,1.42"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
          <path
            d="M15.54,23a12,12,0,0,1-2.37.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
          <path
            d="M10.83,23.47A12,12,0,0,1,8.46,23"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
          <path
            d="M6.32,22a12,12,0,0,1-2-1.42"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
          <path
            d="M2.78,18.89A11.33,11.33,0,0,1,1.53,16.8"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5px"></path>
        </g>
        <path
          d="M13,9.53l-2.29,2.68a.49.49,0,0,0-.08.53.5.5,0,0,0,.46.29h1.82a.51.51,0,0,1,.46.29.51.51,0,0,1-.08.54L11,16.53"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5px"></path>
      </g>
    </svg>
  </ng-template>

  <ng-template #editDeviceIcon>
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_481_22651)">
        <circle cx="38" cy="35" r="24" fill="white" />
        <circle cx="38" cy="35" r="23.5" stroke="#DBE1E2" />
      </g>
      <g clip-path="url(#clip0_481_22651)">
        <path
          d="M29.4981 43C29.3661 43 29.2374 42.9467 29.1441 42.8533C29.0201 42.7293 28.9701 42.546 29.0134 42.376L30.1934 37.7727C30.1974 37.758 30.2074 37.7307 30.2134 37.7167C30.2141 37.714 30.2181 37.7033 30.2234 37.692C30.2507 37.632 30.2834 37.5833 30.3241 37.5433L40.0081 27.8593C40.5581 27.3067 41.2914 27.002 42.0734 27C42.8587 27 43.5914 27.3027 44.1441 27.8527L44.1634 27.872C44.7107 28.4327 45.0061 29.1707 44.9974 29.9527C44.9881 30.7347 44.6761 31.4653 44.1174 32.0107L34.4547 41.6733C34.4134 41.7147 34.3634 41.7487 34.3007 41.776C34.2687 41.79 34.2487 41.798 34.2267 41.804L29.6214 42.9853C29.5807 42.9953 29.5394 43 29.4981 43ZM30.1921 41.806L33.1321 41.052L30.9447 38.8687L30.1921 41.806ZM34.1041 40.6093L42.7841 31.9293L40.0681 29.2133L31.3861 37.896L34.1041 40.6093ZM43.4901 31.2213C44.1774 30.4713 44.1667 29.3067 43.4507 28.5733L43.4374 28.56C43.0747 28.1993 42.5921 28 42.0794 28V27.75L42.0787 28C41.5894 28.0013 41.1314 28.1807 40.7761 28.508L43.4901 31.2213Z"
          fill="#3C4D6A" />
      </g>
      <defs>
        <filter id="filter0_d_481_22651" x="0" y="0" width="76" height="76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="7" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.866667 0 0 0 0 0.917647 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_481_22651" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_481_22651" result="shape" />
        </filter>
        <clipPath id="clip0_481_22651">
          <rect width="16" height="16" fill="white" transform="translate(29 27)" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #manageDeviceIcon>
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_481_22651)">
        <circle cx="38" cy="35" r="24" fill="white" />
        <circle cx="38" cy="35" r="23.5" stroke="#DBE1E2" />
      </g>
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M37 43C35.8972 43 35 41.9907 35 40.75C35 39.5093 35.8972 38.5 37 38.5C38.1028 38.5 39 39.5093 39 40.75C39 41.9907 38.1028 43 37 43ZM37 39.5C36.3873 39.5 35.8889 40.0607 35.8889 40.75C35.8889 41.4393 36.3873 42 37 42C37.6127 42 38.1111 41.4393 38.1111 40.75C38.1111 40.0607 37.6127 39.5 37 39.5Z"
        fill="#3C4D6A" />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M37 37.25C35.8972 37.25 35 36.2407 35 35C35 33.7593 35.8972 32.75 37 32.75C38.1028 32.75 39 33.7593 39 35C39 36.2407 38.1028 37.25 37 37.25ZM37 33.75C36.3873 33.75 35.8889 34.3107 35.8889 35C35.8889 35.6893 36.3873 36.25 37 36.25C37.6127 36.25 38.1111 35.6893 38.1111 35C38.1111 34.3107 37.6127 33.75 37 33.75Z"
        fill="#3C4D6A" />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M37 31.5C35.8972 31.5 35 30.4907 35 29.25C35 28.0093 35.8972 27 37 27C38.1028 27 39 28.0093 39 29.25C39 30.4907 38.1028 31.5 37 31.5ZM37 28C36.3873 28 35.8889 28.5607 35.8889 29.25C35.8889 29.9393 36.3873 30.5 37 30.5C37.6127 30.5 38.1111 29.9393 38.1111 29.25C38.1111 28.5607 37.6127 28 37 28Z"
        fill="#3C4D6A" />
      <defs>
        <filter id="filter0_d_481_22651" x="0" y="0" width="76" height="76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="7" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.847059 0 0 0 0 0.866667 0 0 0 0 0.917647 0 0 0 0.75 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_481_22651" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_481_22651" result="shape" />
        </filter>
      </defs>
    </svg>
  </ng-template>
  <ng-template #warningIcon>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99997 13.5C7.58665 13.5 7.25 13.1633 7.25 12.75C7.25 12.3367 7.58665 12 7.99997 12C8.41328 12 8.74993 12.3367 8.74993 12.75C8.74993 13.1633 8.41328 13.5 7.99997 13.5Z"
        fill="#E16D01" />
      <path
        d="M7.99998 11C7.72399 11 7.5 10.776 7.5 10.5V5.5C7.5 5.224 7.72399 5 7.99998 5C8.2753 5 8.49996 5.224 8.49996 5.5V10.5C8.49996 10.7753 8.2753 11 7.99998 11Z"
        fill="#E16D01" />
      <path
        d="M1.5153 16C1.28397 16 1.05332 15.946 0.846658 15.8447C0.484674 15.6667 0.212686 15.3573 0.082025 14.9747C-0.0486359 14.592 -0.0226371 14.1807 0.156022 13.8187L6.47041 0.952667C6.63574 0.616 6.91239 0.34 7.24838 0.174667C7.48437 0.0586667 7.73636 0 7.99768 0C8.65365 0 9.24096 0.364667 9.52961 0.952667L15.8447 13.818C15.946 14.0247 16 14.2553 16 14.4867C16 14.8913 15.842 15.272 15.5553 15.5573C15.27 15.8427 14.89 16 14.4861 16H1.5153ZM7.99835 1C7.89102 1 7.78636 1.024 7.68969 1.072C7.55103 1.14 7.43637 1.25467 7.36837 1.39333L1.05332 14.2593C0.927988 14.514 1.03332 14.8227 1.28797 14.9473C1.35797 14.982 1.43597 15 1.51396 15H14.4854C14.6234 15 14.7521 14.9467 14.8494 14.85C14.9467 14.7527 15 14.624 15.0007 14.4867C15.0007 14.408 14.9827 14.33 14.948 14.26L8.63165 1.39333C8.51432 1.15467 8.26633 1 7.99835 1Z"
        fill="#E16D01" />
    </svg>
  </ng-template>
</div>
